import { useDrawerWidthResize } from "@ryde/layout";
import {
  REPORT_CHART_DRAWER_DEFAULT_WIDTH,
  REPORT_CHART_DRAWER_MIN_WIDTH,
  REPORT_CHART_DRAWER_RESIZE_KEYBOARD_STEP,
} from "@ryde/shared";

export const useReportChartDrawerResize = () =>
  useDrawerWidthResize({
    defaultWidth: REPORT_CHART_DRAWER_DEFAULT_WIDTH,
    minWidth: REPORT_CHART_DRAWER_MIN_WIDTH,
    keyboardStep: REPORT_CHART_DRAWER_RESIZE_KEYBOARD_STEP,
  });
